import * as React from "react";
import type { Agent, Recommendation } from "@/data/types";
import { Reveal, Overline } from "./primitives";

interface Props {
  recommendation: Recommendation;
  agent: Agent;
}

export const AgentRecommendation: React.FC<Props> = ({
  recommendation,
  agent,
}) => {
  if (!recommendation?.body) return null;

  return (
    <section
      className="w-full bg-ivory py-20 md:py-28"
      data-testid="agent-recommendation"
      aria-label="My recommendation"
    >
      <div className="mx-auto w-full max-w-3xl px-6 md:px-10">
        <Reveal>
          <Overline>My recommendation</Overline>
          <p className="mt-8 font-serif text-2xl leading-[1.4] text-charcoal md:text-3xl">
            {recommendation.body}
          </p>
          {recommendation.closing && (
            <p className="mt-6 text-base leading-relaxed text-charcoal-soft md:text-lg">
              {recommendation.closing}
            </p>
          )}
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 flex items-center gap-4 border-t border-charcoal/10 pt-8">
            {agent.photoUrl && (
              <img
                src={agent.photoUrl}
                alt={agent.name}
                loading="eager"
                decoding="async"
                className="h-16 w-16 shrink-0 rounded-full object-cover object-top md:h-20 md:w-20"
              />
            )}
            <div>
              <p className="signature text-2xl text-charcoal md:text-3xl">
                {agent.name}
              </p>
              {(agent.title || agent.team || agent.brokerage) && (
                <p className="mt-1 text-xs uppercase tracking-[0.16em] text-charcoal-muted">
                  {[agent.title, agent.team, agent.brokerage].filter(Boolean).join(" · ")}
                </p>
              )}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
